import { render } from "./MonParcour.vue?vue&type=template&id=096be054&scoped=true&ts=true"
import script from "./MonParcour.vue?vue&type=script&lang=ts"
export * from "./MonParcour.vue?vue&type=script&lang=ts"

import "./MonParcour.vue?vue&type=style&index=0&id=096be054&scoped=true&lang=css"

import exportComponent from "/workspaces/theokoel.com/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-096be054"]])

export default __exports__